import useGetApi from "../useGetApi"
import useMutateApi from "../useMutateApi"
import getUrl from "api/apiMap"
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

export const useGetGridPresets = (gridIdent) => {
  return useGetApi(
    `${getUrl(apiEndpoints.gridPresets)}`,
    queryKeys.gridPresets.gridDetails(gridIdent),
    {},
    { "preset-ident": gridIdent } // axiosParams, aka, query string
  )
}

export const usePostGridPreset = (gridIdent) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.gridPresets)}`,
    invalidateQueries: [queryKeys.gridPresets.gridDetails(gridIdent)],
    successMsg: "Successfully created preset",
  })
}

export const usePutGridPreset = (gridIdent) => {
  return useMutateApi({
    method: "put",
    apiEndpoint: `${getUrl(apiEndpoints.gridPresets)}`,
    invalidateQueries: [queryKeys.gridPresets.gridDetails(gridIdent)],
    successMsg: "Successfully updated preset",
  })
}

export const useDeleteGridPreset = (gridIdent) => {
  return useMutateApi({
    method: "delete",
    apiEndpoint: `${getUrl(apiEndpoints.gridPresets)}`,
    invalidateQueries: [queryKeys.gridPresets.gridDetails(gridIdent)],
    successMsg: "Successfully deleted preset",
  })
}
